import { Icon } from "./Icon";

type Props = {
  value: number;
  onChange: (n: number) => void;
  min?: number;
  max?: number;
};

export function QtyStepper({ value, onChange, min = 1, max = 9999 }: Props) {
  return (
    <div className="tcg-qty-row">
      <button
        type="button"
        className="tcg-qty-btn"
        onClick={() => onChange(Math.max(min, value - 1))}
        aria-label="meno"
        disabled={value <= min}
      >
        <Icon name="minus" size={18} />
      </button>
      <input
        type="number"
        className="tcg-qty-display tcg-num"
        value={value}
        min={min}
        max={max}
        onChange={(e) => {
          const raw = parseInt(e.target.value || "0", 10);
          const clamped = Math.max(min, Math.min(max, Number.isNaN(raw) ? min : raw));
          onChange(clamped);
        }}
        onFocus={(e) => e.currentTarget.select()}
      />
      <button
        type="button"
        className="tcg-qty-btn"
        onClick={() => onChange(Math.min(max, value + 1))}
        aria-label="più"
        disabled={value >= max}
      >
        <Icon name="plus" size={18} />
      </button>
    </div>
  );
}
